


















import Component from "vue-class-component";
import {
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Vue,
  Watch
} from "vue-property-decorator";
interface Item {
  value: string; // 对应form属性
  name: string; // label展示
  component?: string; // 组件名
  componentVue?: any; // import的vueComponent
  default?: any; // form属性初始值
  style?: any; // item样式
  rules?: Array<{
    // 表单规则
    required?: boolean;
    message: string;
    type?: string;
    trigger?: string;
  }>;
  placeholder?: string; // input提示
  options?: Array<{
    // select的下拉框
    key: string; // 后端接收
    value: any; // 前端展示
  }>;
}
@Component({
  name: "DefaultForm",
  components: {}
})
export default class DefaultForm extends Vue {
  // 数据
  @Prop({ default: null })
  private data: any;
  // 表单item循环配置
  @Prop({
    default: () => {
      return [];
    }
  })
  private formConfig!: any[]; // Item
  // 表单方法传入
  @Prop({
    default: () => {
      return {
        submit: (data: any) => {
          console.log("no Submit");
        }
      };
    }
  })
  private formOptions: any;
  // 传入的表单
  @Prop({
    default: () => {
      return {};
    }
  })
  private formParam: any;
  private loading: boolean = false;
  private get param() {
    return this.formParam;
  }
  private set param(val: any) {
    this.$emit("update:formParam", val);
  }
  @Watch("data")
  private dataChange(val: any) {
    if (val) {
      Object.keys(this.data).map((key: any) => {
        if (_.has(this.data, key)) {
        this.param[key] = this.data[key];
        const param: any = _.cloneDeep(this.param)
        param[key] = this.data[key]
        this.param = param
        // this.$set(this.param, key, this.data[key])
        }
      });
      
    }
  }

  // 重置表单
  private resetForm() {
    const defaultForm: any = this.$refs.defaultForm;
    defaultForm.resetFields();
  }

  private hasPath(obj: any, path: string) {
    return _.has(obj, path);
  }
  // 初始化param 和component 依赖于v-if
  private formConfigChange(cb: () => void) {
    this.formConfig.forEach((conf: any) => {
      // param初始化
      if (!!!conf.notParam) {
        if (!this.param[conf.value]) {
          this.param[conf.value] = _.has(conf, "default") ? conf.default : "";
        }
      }
      if (conf.componentVue) {
        // 需要保证配置config在form操作之前
        Vue.component(conf.component, conf.componentVue);
      }
    });
    if (cb) {
      cb();
    }
    this.loading = true;
  }
  private mounted() {
    _.assign(this.param, _.cloneDeep(this.data));
    this.formConfigChange(() => {
      if (this.data) {
        Object.keys(this.param).map((key: any) => {
          // if (_.has(this.data, key)) {
          this.param[key] = this.data[key];
          // }
        });
      }
    });
  }
  private submit(cb: (data: any) => void) {
    const defaultForm: any = this.$refs.defaultForm;
    defaultForm.validate(async (valid: any) => {
      if (valid) {
        if (this.formOptions.submit) {
          await this.formOptions.submit(this.param);
        }
        cb(valid);
      } else {
        cb(valid);
      }
    });
  }
}
